export const library = {
  title: "Library",
  searchPlaceholder: "Search library",
  manageLibrary: "Manage Library | GlobalComix",
};
